import { UserProfile } from '../api/auth';

export const getUserDisplayName = (user?: UserProfile | null): string => {
  if (!user) {
    return 'Unknown user';
  }

  const name = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  if (name) {
    return name;
  }

  return user.username || 'Unknown user';
};
